<input
  type="text"
  autocomplete="off"
  [readonly]="readonly"
  class="form-control bg-dark text-center"
  name="sticpaydepositThreshold"
  [mask]="mask"
  [dropSpecialCharacters]="_precision === 0"
  [value]="stringValue"
  [min]="min"
  [max]="max"
  [disabled]="disabled"
  [required]="required"
  (input)="onInput($event)"
/>